/**
 * Catálogo de roles por tipo de cliente (arquitectura 2.15, sección 13). Son roles del cliente
 * `plataforma` en Keycloak y los lleva cada usuario de un negocio (lotero, yonkero o proveedor).
 * Los de Siniestrados (superadmin, soporte, compras, valuador, tesoreria) son roles del realm y
 * no entran aquí.
 */
export const ROLES_LOTERO = [
    // Lotero: existían desde el MVP0.
    'dueno',
    'vendedor',
    'patio',
    'taller',
    'contador',
    // Lotero: MVP3 (arquitectura 2.15).
    'gerente',
    'comprador',
    'mecanico',
    // Yonkero: MVP3.
    'desarmador',
    'mostrador',
    // Proveedor: MVP3 (el administrador del proveedor es su dueño).
    'operador',
];
/** Nombre visible de cada rol. */
export const NOMBRE_ROL = {
    dueno: 'Dueño',
    vendedor: 'Vendedor',
    patio: 'Patio',
    taller: 'Taller',
    contador: 'Contador',
    gerente: 'Gerente',
    comprador: 'Comprador de subastas',
    mecanico: 'Mecánico',
    desarmador: 'Desarmador',
    mostrador: 'Mostrador',
    operador: 'Operador (proveedor)',
};
/** Qué hace cada rol, en palabras del negocio (misma tabla que el API). */
export const DESCRIPCION_ROL = {
    dueno: 'Todo, incluidos usuarios, plan, sitio, pagos y decisiones de compra',
    vendedor: 'Vehículos, publicaciones, leads, pedidos, compras, valuaciones y encargos',
    patio: 'Vehículos, piezas, ubicaciones y pasos de importación; sin montos',
    taller: 'Órdenes, tareas, estimaciones y proveedores; sin montos de compra',
    contador: 'Costos, compras, valuaciones, pedimentos y pagos a proveedores',
    gerente: 'La operación completa y los usuarios; sin plan, dominio ni datos fiscales',
    comprador: 'Lotes, dictamen, puja máxima, compras, valuaciones, importación y encargos',
    mecanico: 'Solo sus órdenes y tareas del taller, con reloj y fotos; sin montos',
    desarmador: 'Desarme: alta y estado de las piezas de cada auto; sin precios de compra',
    mostrador: 'Buscar, apartar y vender piezas, leads y pedidos; sin costos',
    operador: 'Portal de Proveedores: convocatorias, ofertas y trabajos; sin perfil ni cobros',
};
/** A qué tipo de cuenta pertenece cada rol (para agruparlos en pantalla). */
export const CUENTA_DEL_ROL = {
    dueno: 'lotero',
    vendedor: 'lotero',
    patio: 'lotero',
    taller: 'lotero',
    contador: 'lotero',
    gerente: 'lotero',
    comprador: 'lotero',
    mecanico: 'lotero',
    desarmador: 'yonkero',
    mostrador: 'yonkero',
    operador: 'proveedor',
};
/** Roles que una cuenta de proveedor reparte en su equipo: su dueño (administrador) y operadores. */
export const ROLES_PROVEEDOR = ['dueno', 'operador'];
//# sourceMappingURL=roles.js.map